import { RPReviewReasonModel, TeamMembers } from './TeamMembers';
import { DecisionsApiLogModel } from './DecisionsApiLogModel';


export class DecisionsRPListModel{
    isSuccess: boolean;
    workspaceId: string;
    decisionsRPList: TeamMembers[] = []; 
    rPReviewReasonList: RPReviewReasonModel[] = [];
    riskPoints: number;
    errorCode: string;
    errorDescription: string;
    loggedInUserFullName: string;
    isDecisionsValuePersisted: boolean;
    engageUIStatus: string;
    decisionsApiLogModel: DecisionsApiLogModel = new DecisionsApiLogModel();
}